import { PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { contactTypeService } from "../api/contactType";

interface Props {
	name: string;
	label: string;
	clearable?: boolean;
	required?: boolean;
	disabled?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(contactTypeService);

export const ContactTypeSingleSelect: FC<Props> = ({ name, label, clearable, required, disabled }) => {
	return (
		<PagedSingleSelectField
			name={name}
			label={label}
			clearable={clearable}
			required={required}
			disabled={disabled}
			fetchConfig={fetchConfig}
		/>
	);
};
